import './About.scss'

const About = () => {

    return (
        <section className='about'>
            <div className='about__content'>
                <div className='about__content__subtitle text'>
                    - quién soy -
                </div>
                <h2 className='about__content__title'>Sobre mí</h2>
                <div className='about__content__info'>
                    <div className='about__content__info__text'>
                        <p>
                        Soy un Desarrollador Frontend junior, aficionado por la tecnología y la programación. <br/>Creo sitios y aplicaciones web personalizadas, efectivas, limpias y modernas; usando las mejores prácticas de programación. <br/>Las herramientas que uso principalmente son HTML, CSS, JAVASCRIPT y REACT JS. <br/>Actualmente estoy disponible para ofertas laborales en roles de maquetado o desarrollo frontend y proyectos freelance.
                        </p>
                    </div>
                    <div className='about__content__info__img'>
                        <img src='./assets/images/aboutme.jpg' alt='programador trabajando'/>
                    </div>
                </div>
                <div className='about__content__cv'>
                    <a href='./assets/docs/cv.pdf' download='Curriculum Vitae - Fredy Rodrigo'>
                        Descargar CV
                        <img src='./assets/icons/download.svg' alt='icono de flecha a la derecha'/>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default About;